module.exports = __webpack_public_path__ + "media/images/swifticons/weather-rain-1ac2782abc84ecd0911e8ad20e47deac.svg";